// La versión sale de package.json al compilar (una sola fuente; el pie la muestra).
import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://apista.smartclock.cl/v1/',
  appName: 'SMARTCLOCK BACKOFFICE',
  version: packageJson.version,
};
